function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "200116_VF_Icon_All_Smiley_outline"), /*#__PURE__*/React.createElement("path", {
  d: "M103.1 92.1c-10 0-18 5.5-18 17.7s8.1 17.7 18 17.7 18-5.5 18-17.7-8.1-17.7-18-17.7zM180.4 92.1c-10 0-18 5.5-18 17.7s8.1 17.7 18 17.7 18-5.5 18-17.7-8.1-17.7-18-17.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 35.4c33.9 0 62.2 8.9 81.7 25.7 21 18.1 31.7 45.2 31.7 80.6s-10.6 62.5-31.7 80.6c-19.5 16.8-47.8 25.6-81.7 25.6S79.5 239 60 222.3c-21-18.1-31.6-45.2-31.6-80.6S39 79.2 60 61.1c19.5-16.8 47.8-25.7 81.7-25.7m0-28.3C63.5 7.1 0 49 0 141.7s63.5 134.7 141.7 134.7 141.7-41.9 141.7-134.7S220 7.1 141.7 7.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85 170h113.4v28.5H85z"
})));